import React from 'react'
import { HiCheckCircle, HiXCircle, HiQuestionMarkCircle, HiArrowTrendingUp } from 'react-icons/hi2'

interface PredictionOutcomeBadgeProps {
  predictedWinner: string | null
  homeScore: number | null
  awayScore: number | null
  className?: string
  showOutcome?: boolean // If false, shows prediction value instead of outcome
}

const PredictionOutcomeBadge: React.FC<PredictionOutcomeBadgeProps> = ({
  predictedWinner,
  homeScore,
  awayScore,
  className = '',
  showOutcome = true
}) => {
  // Debug: Log what we received
  console.log('PredictionOutcomeBadge props:', { predictedWinner, homeScore, awayScore, showOutcome })
  
  const hasPrediction = predictedWinner !== null && predictedWinner !== undefined
  
  // If showing only prediction (for Upcoming/Live games), no scores needed
  if (!showOutcome) {
    if (!hasPrediction) {
      return (
        <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-900/40 text-gray-200 border border-gray-700 ${className}`}>
          <HiQuestionMarkCircle className="h-4 w-4 mr-1" />
          No Prediction
        </div>
      )
    }
    
    // Format prediction text
    const predictionText = predictedWinner === 'HOME' ? 'Home Win' 
      : predictedWinner === 'AWAY' ? 'Away Win' 
      : 'Draw'
    
    return (
      <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-orange-900/30 text-orange-300 border border-orange-700 ${className}`}>
        <HiArrowTrendingUp className="h-4 w-4 mr-1" />
        Predicted: {predictionText}
      </div>
    )
  }
  
  // Original logic for finished games with outcome
  // Determine if we have enough data to evaluate prediction
  // Check for null or undefined (but allow 0 as a valid score)
  const hasScores = (homeScore !== null && homeScore !== undefined) && (awayScore !== null && awayScore !== undefined)
  
  console.log('Badge checks:', { hasScores, hasPrediction })

  if (!hasScores || !hasPrediction) {
    return (
      <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-900/40 text-gray-200 border border-gray-700 ${className}`}>
        <HiQuestionMarkCircle className="h-4 w-4 mr-1" />
        {!hasScores ? 'Score Unavailable' : 'No Prediction'}
      </div>
    )
  }

  // Determine actual winner
  let actualWinner: string
  if (homeScore > awayScore) {
    actualWinner = 'HOME'
  } else if (awayScore > homeScore) {
    actualWinner = 'AWAY'
  } else {
    actualWinner = 'DRAW'
  }

  // Check if prediction was correct
  const isCorrect = predictedWinner === actualWinner

  if (isCorrect) {
    return (
      <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-900/30 text-green-300 border border-green-700 ${className}`}>
        <HiCheckCircle className="h-4 w-4 mr-1" />
        Correct Prediction
      </div>
    )
  } else {
    return (
      <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-900/30 text-red-300 border border-red-700 ${className}`}>
        <HiXCircle className="h-4 w-4 mr-1" />
        Incorrect Prediction
      </div>
    )
  }
}

export default PredictionOutcomeBadge
